import React from "react";
import { BrowserView, MobileView, isMobile } from "react-device-detect";
import WebRouter from "./routers/WebRouter";
import MobileWebRouter from "./routers/MobileWebRouter";
import ErrorBoundary from "./components/ErrorBoundary";
import store from "./Redux/store";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <>
      <MobileView>
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
        <ErrorBoundary>
          <MobileWebRouter />
        </ErrorBoundary>
      </MobileView>
      <BrowserView>
        <ToastContainer rtl />
        <WebRouter />
      </BrowserView>
      <CookieBanner />
    </>
  );
}

export default App;
